import { BrandVolumeProvider, ThemeProvider } from '@klarna/bubble-ui'
import React, { useEffect, useRef, useState } from 'react'

import { CustomOverrides } from '@bubble-contrib/provider-custom-overrides'
import ThemeContext from 'common/contexts/theme'
import themes from 'themes'
import useHppContext from 'common/hooks/use-hpp-context'

function ThemeLoader({ issuer = 'klarna', isNotEmpty = false, children }) {
  const [theme, setTheme] = useState(null)
  const { theme: themeFromSettings = null } = useHppContext()
  const mountedRef = useRef(true)

  useEffect(() => {
    const loadTheme = themes[issuer] || themes.klarna

    loadTheme().then(({ default: theme }) => {
      if (mountedRef.current) {
        setTheme({
          ...theme,
          ...(themeFromSettings ? { bubbleUIOverrides: themeFromSettings } : {})
        })
      }
    })

    return () => {
      mountedRef.current = false
    }
  }, [])

  if (!theme) {
    return isNotEmpty ? children : null
  }

  return theme.bubbleUIOverrides ? (
    <ThemeProvider theme={theme.bubbleUIOverrides} customOverrides={CustomOverrides}>
      <BrandVolumeProvider low>
        <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
      </BrandVolumeProvider>
    </ThemeProvider>
  ) : (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  )
}

export default ThemeLoader
